import entities from 'src/config/entities';
import BaseService from "./BaseService";

class CreditService extends BaseService {
  constructor() {
    super({entity: entities.CREDIT});
  }

  getCreditLogs(params, path) {
    return super.get(params, path);
  }

}

export default new CreditService();
